import {Component, input, output, viewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AutoComplete, AutoCompleteModule} from 'primeng/autocomplete';
import {Button} from 'primeng/button';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-model-field-autocomplete',
  imports: [FormsModule, AutoCompleteModule, Button, TranslocoPipe],
  templateUrl: './model-field-autocomplete.component.html',
})
export class ModelFieldAutocompleteComponent {
  readonly value = input<any>();
  readonly suggestions = input<any[]>([]);
  readonly placeholder = input<string>('');
  readonly optionLabel = input.required<string>();
  readonly itemIdField = input<string>('');
  readonly disabled = input<boolean>(false);
  readonly testId = input<string>('');
  readonly addButtonLabel = input<string>('');
  readonly addButtonDisabled = input<boolean>(false);
  readonly isCustom = input<(item: any) => boolean>(() => false);
  readonly delay = input(300);
  readonly enterAlwaysAdds = input(false);

  readonly valueChange = output<any>();
  readonly inputChange = output<{query: string}>();
  readonly dropdownOpen = output<void>();
  readonly add = output<void>();
  readonly deleteItem = output<any>();
  readonly cleared = output<void>();

  private readonly autocomplete = viewChild<AutoComplete>('autocomplete');

  onComplete(event: {query: string}): void {
    this.inputChange.emit(event);
  }

  onEnter(event: Event): void {
    const hasSuggestions = this.suggestions().some(
      (group) => group.items && group.items.length > 0,
    );

    if ((this.enterAlwaysAdds() || !hasSuggestions) && !this.addButtonDisabled()) {
      event.preventDefault();
      this.add.emit();
    }
  }

  onDelete(item: any, event: Event): void {
    event.stopPropagation();
    this.deleteItem.emit(item);
  }

  clear(): void {
    this.autocomplete()?.clear();
  }

  hide(): void {
    this.autocomplete()?.hide();
  }
}
